export enum InviteeType {
  Group = "Group",
  Individual = "Individual"
}
